module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"joinUs":"Join the network","sectionLocation":"Our adress","sectionMail":"Our email","sectionPhone":"Our phone number"},"fr":{"joinUs":"Rejoignez le réseau","sectionLocation":"Notre adresse","sectionMail":"Notre mail","sectionPhone":"Notre numéro"}}')
  delete Component.options._Ctor
}
